export const getUserRequest = () => {
  return fetch(`${process.env.REACT_APP_PURRS_API_HOST}/api/v1/sessions`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json;",
    },
  })
  .then((response) => response.json())
  .then((data) => {
    return data;
  })
  .catch((error) => {
    console.log("Session error", error);
  });
}